import {LocalizedContent} from "./localized-content";
import { LocalizedContentFieldCreator } from './localized-content-field-creator';

export function toLocalized(fields) {
  return new LocalizedContentFieldCreator(fields).getArray();
}

